// CustomButton.js
import React from "react";
import "./CustomButton.css";

const CustomButton = ({
  variant = "filled",
  children,
  onClick,
  type = "button",
  className = "",
  loading = false,
  disabled = false,
  ...props
}) => {
  return (
    <button
      type={type}
      className={`custom-button ${variant === "outlined" ? "outlined" : "filled"} ${className}`}
      onClick={onClick}
      disabled={loading || disabled} // ✅ disable when loading
      {...props}
    >
      {loading ? (
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
      ) : children}
    </button>
  );
};

export default CustomButton;
